import {
    AfterViewInit,
    Component,
    OnDestroy,
    OnInit,
    ViewChild
} from '@angular/core';
import { StepIds } from '../../../models/property-step/property-step-model';
import { PropertyAboutSectionComponent } from '../../../sections/property-default-sections/property-about-section/property-about-section.component';
import { DraftFacade } from '@classifieds-sell/state';
import { RouterFacade } from '@classifieds-sell/state';
import { PropertyPageBase } from '../../property-page-base';
import { PropertyListingTitleSectionComponent } from '../../../sections/residential-for-sale/property-listing-title-section/property-listing-title-section.component';
import { PropertyAgencyReferenceSectionComponent } from '../../../sections/residential-for-sale-agent/property-agency-reference-section/property-agency-reference-section.component';
import { PropertySaleAttributeSectionComponent } from '../../../sections/sections-for-sale/property-sale-attribute-section/property-sale-attribute-section.component';

@Component({
    templateUrl: './property-description-page.component.html',
    styleUrls: ['./property-description-page.component.scss'],
    host: { 'data-variant': 'sections-for-sale' },
    standalone: false
})
export class PropertyDescriptionComponent
    extends PropertyPageBase
    implements AfterViewInit, OnInit, OnDestroy {
    @ViewChild(PropertyListingTitleSectionComponent, {
        read: PropertyListingTitleSectionComponent
    })
    propertyListingTitleSectionComponent: PropertyListingTitleSectionComponent;

    @ViewChild(PropertyAboutSectionComponent, {
        read: PropertyAboutSectionComponent
    })
    propertyAboutSectionComponent: PropertyAboutSectionComponent;

    @ViewChild(PropertySaleAttributeSectionComponent, {
        read: PropertySaleAttributeSectionComponent
    })
    propertySaleAttributeSectionComponent: PropertySaleAttributeSectionComponent;

    @ViewChild(PropertyAgencyReferenceSectionComponent, {
        read: PropertyAgencyReferenceSectionComponent
    })
    propertyAgencyReferenceSectionComponent: PropertyAgencyReferenceSectionComponent;

    constructor(draftFacade: DraftFacade, routerFacade: RouterFacade) {
        super(StepIds.propertyDescription, draftFacade, routerFacade);
    }

    ngOnInit(): void {
        super.onInit();
    }

    ngOnDestroy(): void {
        super.onDestroy();
    }

    ngAfterViewInit() {
        super.registerSection(this.propertyListingTitleSectionComponent);
        super.registerSection(this.propertyAboutSectionComponent);
        super.registerSection(this.propertySaleAttributeSectionComponent);
        super.registerSection(this.propertyAgencyReferenceSectionComponent);
    }
}
